import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateAppleTouchIcons } from '../utils/updateAppleTouchIcons';

export function AppleTouchIconUpdater() {
  const location = useLocation();

  useEffect(() => {
    // Update icons when the route changes
    updateAppleTouchIcons(location.pathname);
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
}
